import React from 'react'
import styled from 'styled-components'
import { Config } from '../../../config'

export const Copy = ({ html }: { html?: string }) => {
  if (!html) return null

  return <StyledCopy dangerouslySetInnerHTML={{ __html: html }} />
}

const StyledCopy = styled.span`
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.greyTitle};

  & img {
    max-width: 100%;
  }

  & a {
    color: ${({ theme }) => theme.palette.silverTree};

    &:hover {
      text-decoration: underline;
    }
  }

  & ul {
    & li {
      display: flex;

      &:before {
        content: '';
        display: inline-block;
        min-width: 0.6rem;
        min-height: 0.6rem;
        max-width: 0.6rem;
        max-height: 0.6rem;
        background: ${({ theme }) => theme.palette.greyTitle};
        vertical-align: middle;
        margin-right: 1rem;
        border-radius: 50%;
        margin-top: 0.9rem;
      }
    }
  }

  & ol {
    list-style-type: decimal;
    list-style-position: inside;
  }

  & h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    padding-bottom: 0.5rem;
    &:last-child {
      padding-bottom: 0;
    }
  }

  & table {
    text-align: left;
    width: 100%;
  }

  & th,
  td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-right: 1.6rem;
    border-bottom: 1px solid ${({ theme }) => theme.palette.disabled};
  }
`
